import { create } from 'zustand'
import { chainId } from '../../../config/constants/chains'
const useConnectWalletModalStore = create((set) => ({
	isOpen: false,
	isIdle: true,
	isLoading: false,
	isSuccess: false,
	chainId: chainId.ETHEREUM,
	callback: () => {},
	actions: {
		toggleConnectWalletModal: () =>
			set((state) => ({
				...state,
				isOpen: !state.isOpen
			})),
		closeConnectWalletModal: () =>
			set((state) => ({
				...state,
				isOpen: false
			})),
		setConnectWalletModalState: (newState) =>
			set((state) => ({
				...state,
				...newState
			}))
	}
}))

export const useConnectWalletModalState = () =>
	useConnectWalletModalStore(
		({ isOpen, isIdle, isLoading, isSuccess, chainId, callback }) => ({
			isOpen,
			isIdle,
			isLoading,
			isSuccess,
			chainId,
			callback
		})
	)

export const useConnectWalletModalActions = () =>
	useConnectWalletModalStore((state) => state.actions)
